export const News = [
  {
    path: '/news/:app_module_id',
    name: 'news.index',
    component: () => import('@/pages/News/NewsModule')
  },
  {
    path: '/news/:app_module_id/post/:id/edit/',
    name: 'news.edit',
    component: () => import('@/pages/News/NewsEdit')
  },
  {
    path: '/news/:app_module_id/post/:id',
    name: 'news.item',
    component: () => import('@/pages/News/NewsPage')
  }
]
